export const AUTOMATIC_PENTESTING = {
  TITLE: 'Pentesting Automatizado',
  DASHBOARD_CARD: {
    TITLE: 'Panel',
    DESCRIPTION:
      'Resumen de vulnerabilidades identificadas en tu infraestructura, destacando ' +
      'los problemas críticos y las detecciones recientes para una visión rápida.',
    URLS: {
      HISTORIC: 'Panel de vulnerabilidades históricas',
      LAST_SCAN: 'Panel del último escaneo',
    },
  },
  REPORT_CARD: {
    TITLE: 'Informes',
    DESCRIPTION:
      'Un informe detallado de vulnerabilidades que abarca tanto superficies internas ' +
      'como externas. Este informe proporciona un análisis profundo de los posibles puntos de ' +
      'entrada y riesgos que podrían ser explotados desde dentro o fuera de la red.',
    DOWNLOAD: 'Informe del último escaneo de superficie externa',
    INTERNAL: 'Informe del último escaneo de vulnerabilidades',
    EXTERNAL: 'Informe del último escaneo de superficie externa',
    CLOUD: 'Informe de la última auditoría en la nube',
    CLOUD_DASHBOARD: 'Panel de auditoría en la nube',
  },
  CONFIGURATION_CARD: {
    TITLE: 'Documentación',
    DESCRIPTION:
      'Guías de conexión para clientes, incluyendo pasos para conectar de forma segura ' +
      'los entornos del cliente con la plataforma.',
    AWS: 'Conectando tus redes privadas con Qalea (AWS)',
    GCP: 'Conectando tus redes privadas con Qalea (GCP)',
    OTHER: 'Conectando tus redes privadas con Qalea (Otros proveedores de nube)',
    READ_ONLY_AWS: 'Crear usuario de solo lectura en tu nube para el descubrimiento de activos (AWS)',
    READ_ONLY_GCP: 'Crear usuario de solo lectura en tu nube para el descubrimiento de activos (GCP)',
  },
  PENDING_ACTIONS: {
    TITLE: 'Acciones Pendientes',
    DESCRIPTION:
      'Aquí puedes ver una lista priorizada de vulnerabilidades no resueltas y acciones ' +
      'recomendadas, manteniendo los esfuerzos de seguridad enfocados y accionables.',
    INSIGHTS_NOT_YET_AVAILABLE:
      'Las acciones pendientes estarán disponibles una vez que se haya ' +
      'recopilado suficiente información de escaneos. Por favor, vuelve más tarde para ver los ' +
      'insights y patrones a medida que surjan.',
  },
}
